import React, {Component} from 'react';
import FilterGenerateList from '../parts/FilterGenerateList';
import Axios from 'axios';
import APIENDPOINT from '../ApiEndpoint';

class KennisVak extends Component {
    constructor(props){
        super(props);
        this.state = {
            typesfull: [],
            filterOptions: []
        }
    }
    
    async componentDidMount(){
        const {data} = await Axios.get(`${APIENDPOINT}/types`);
        let fOptions = [];
        this.setState({typesfull : Object.values(data) });
    }

    findFilterOptions = (needle) => {
        if(this.state.typesfull.length > 0){
            const typeOptions = this.state.typesfull.find(type => type.type_name === needle).options;

            return typeOptions;

        }else{
            return [];
        }
    }

    


    render(){
        const filtersOptions = this.findFilterOptions("Kennis- of vaardigheidsvak");
        return(
            <FilterGenerateList title='Selecteer een vak' filterOptions={filtersOptions}/>
        )
    }
}

export default KennisVak;